import { useLanguage } from "@/context/LanguageContext";
import ScrollReveal from "@/components/ScrollReveal";

export default function LegalPage({ contentKey }) {
  const { t } = useLanguage();
  const content = t[contentKey];

  if (!content) return null;

  return (
    <div className="min-h-screen pt-32 pb-24 bg-[#333333]">
      <div className="max-w-3xl mx-auto px-6 sm:px-12">
        <ScrollReveal>
          <h1
            data-testid={`${contentKey}-title`}
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter mb-4"
          >
            {content.title}
          </h1>
          <p className="text-sm text-white/40 mb-16">{content.lastUpdated}</p>
        </ScrollReveal>

        <div className="space-y-12">
          {content.sections.map((section, i) => (
            <ScrollReveal key={i} delay={i * 50}>
              <section data-testid={`${contentKey}-section-${i}`}>
                <h2 className="text-xl sm:text-2xl font-semibold tracking-tight text-white mb-4">
                  {section.title}
                </h2>
                <div className="text-white/60 leading-relaxed whitespace-pre-line text-sm sm:text-base">
                  {section.content}
                </div>
              </section>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </div>
  );
}
